import * as Dialog from '@radix-ui/react-dialog';

type FeedGuideDialogProps = { showsPages?: boolean };

export const FeedGuideDialog = ({ showsPages = false }: FeedGuideDialogProps) => (
  <Dialog.Root>
    <Dialog.Trigger asChild>
      <button
        type="button"
        className="mt-3 text-sm font-medium text-primary underline-offset-4 hover:underline focus:outline-none focus:ring-2 focus:ring-focus-ring"
      >
        What does this mean?
      </button>
    </Dialog.Trigger>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-40 bg-shadow/50 animate-slideUpAndFade" />
      <Dialog.Content className="fixed left-1/2 top-1/2 z-50 max-h-[85vh] w-[90vw] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-lg bg-surface p-6 shadow-xl animate-slideUpAndFade">
        <Dialog.Title className="text-xl font-medium text-text">Your feed</Dialog.Title>
        <Dialog.Description className="mt-2 text-sm leading-6 text-text-secondary">
          Your feed brings the moments from your tarot journey together in one place.
        </Dialog.Description>
        <dl className="mt-5 grid gap-4">
          <div>
            <dt className="font-medium text-text">Readings</dt>
            <dd className="mt-1 text-sm leading-6 text-text-secondary">
              Your completed card readings. You can return to a reading whenever you need it.
            </dd>
          </div>
          <div>
            <dt className="font-medium text-text">Reflections</dt>
            <dd className="mt-1 text-sm leading-6 text-text-secondary">
              Thoughts you have written about a reading or saved as a personal note.
            </dd>
          </div>
          {showsPages && (
            <div>
              <dt className="font-medium text-text">New pages</dt>
              <dd className="mt-1 text-sm leading-6 text-text-secondary">
                Fresh guidance from This Week in the Inner Circle.
              </dd>
            </div>
          )}
          <div>
            <dt className="font-medium text-text">Card unlocks</dt>
            <dd className="mt-1 text-sm leading-6 text-text-secondary">
              Cards that have joined your collection through your readings.
            </dd>
          </div>
          <div>
            <dt className="font-medium text-text">Monthly patterns</dt>
            <dd className="mt-1 text-sm leading-6 text-text-secondary">
              The three cards that appeared most often after a month has closed.
            </dd>
          </div>
        </dl>
        {/* <a
          href="/feed-guide"
          className="mt-6 inline-block text-sm font-medium text-primary underline-offset-4 hover:underline"
        >
          Learn more about your feed
        </a> */}
        <Dialog.Close asChild>
          <button
            type="button"
            className="mt-6 w-full rounded-lg bg-button-solid-bg px-4 py-2 text-sm font-medium text-text-inverse transition-colors hover:bg-button-solid-bg-hover"
          >
            Close
          </button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
